export default __webpack_public_path__ + "static/media/socialPlayFavIcon.4dd9860c.png";